import * as React from "react";

const DelimiterPopover = (
  <div className="delimiter-popover">
    <p>
      <strong>Delimeter:</strong> A character used to separate data.
    </p>
  </div>
);

export default DelimiterPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportFormat/DelimiterPopover.tsx